import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import SEO from "@/components/seo/SEO";

export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = hash.split("session_id=")[1]?.split("&")[0];

    if (!sessionId) {
      navigate("/login");
      return;
    }

    loginWithGoogleSession(sessionId)
      .then((user) => {
        const postAuthRedirect = localStorage.getItem("ams_post_auth_redirect");
        localStorage.removeItem("ams_post_auth_redirect");
        navigate(postAuthRedirect || "/dashboard", { state: { user } });
      })
      .catch(() => {
        navigate("/login");
      });
  }, [loginWithGoogleSession, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <SEO title="Connexion en cours | Kalypso Music" description="Connexion sécurisée à votre compte Kalypso Music." path="/auth/callback" noindex />
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  );
}
